// import React, { useEffect, useState } from "react";
// import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
// import { Avatar, Breadcrumb, Layout, Menu, message, Tag } from "antd";
// import { MdDashboard, MdOutlineSupervisedUserCircle } from "react-icons/md";
// import {
//   BellOutlined,
//   BuildOutlined,
//   HomeOutlined,
//   LogoutOutlined,
//   MessageOutlined,
//   RestTwoTone,
//   UserOutlined,
//   WalletFilled,
//   WalletTwoTone,
// } from "@ant-design/icons";
// import { TbCategoryPlus } from "react-icons/tb";
// import { VscRequestChanges, VscSymbolProperty } from "react-icons/vsc";
// import { GrServices } from "react-icons/gr";
// import { Header } from "antd/es/layout/layout";
// import { BiBuildingHouse, BiListCheck, BiTransfer, BiWallet } from "react-icons/bi";
// import { useSelector } from "react-redux";
// import { FaClipboardList, FaCrown } from "react-icons/fa";
// import { getDashBoard } from "../ApiServices/Apifun";

// const { Sider, Content } = Layout;

// const BasicLayout = ({ children }) => {
//   const [collapsed, setCollapsed] = useState(false);
//   const [selectedMenu, setSelectedMenu] = useState("");
//   const parm = useLocation();
//   const trimRoute = parm.pathname.split("/")
//   const wallet = useSelector((state) => state.B2B.walletBal);
//   const navigate = useNavigate();
//   const [dashboard, setDashboard] = useState(null);

//   useEffect(() => {
//     const handleResize = () => {
//       window.innerWidth <= 600 ? setCollapsed(true) : setCollapsed(false);
//     };
//     window.addEventListener("resize", handleResize);
//     const stored = localStorage.getItem("selected");
//     if (stored) {
//       setSelectedMenu(stored);
//     }
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const fetchDashboard = () => {
//     getDashBoard()
//       .then((response) => {
//         if (response.status) {
//           setDashboard(response.data || null);
//         }
//       })
//       .catch((err) => {
//         console.error("Error fetching dashboard details:", err);
//       });
//   };
//   useEffect(() => {
//     fetchDashboard();
//   }, []);

//   useEffect(() => {
//     localStorage.setItem("selected", selectedMenu);
//   }, [selectedMenu]);

//   function getlogout() {
//     localStorage.clear();
//     navigate("/");
//     message.success("Vendor Logged Out Successfully");
//   }

//   const layoutStyle = {
//     borderRadius: 8,
//     overflow: "hidden",
//   };
//   const formatDate = (value) => {
//     if (!value) return "-";
//     const d = new Date(value);
//     if (isNaN(d.getTime())) return "-";
//     return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
// };

//   // Add titles to each menu item
//   const menuItems = [
//     {
//       key: "1",
//       icon: <MdDashboard />,
//       label: "Dashboard",
//       title: "Dashboard",
//       onClick: () => {
//         setSelectedMenu("1");
//         navigate("/dashboard");
//       },
//     },

//     {
//       key: "5",
//       icon: <VscRequestChanges />,
//       label: "Order List",
//       title: "Order List",
//       onClick: () => {
//         setSelectedMenu("5");
//         navigate("/orderlist");
//       },
//     },
//     {
//       key: "6",
//       icon: <BiBuildingHouse />,
//       label: "Restro List",
//       title: "Restro List",
//       onClick: () => {
//         setSelectedMenu("6");
//         navigate("/restroList");
//       },
//     },
//     {
//       key: "11",
//       icon: <BiListCheck />,
//       label: "Role Management",
//       title: "Role Management",
//       onClick: () => {
//         setSelectedMenu("11");
//         navigate("/permissionList");
//       },
//     },
//     {
//       key: "2",
//       icon: <FaClipboardList />,
//       label: "Plan Management",
//       title: "Plan Management",
//       onClick: () => {
//         setSelectedMenu("2");
//         navigate("/plans");
//       },
//     },
//     // {
//     //   key: "7",
//     //   icon: <BiTransfer />,
//     //   label: "Transaction List",
//     //   title: "Transaction List",
//     //   onClick: () => {
//     //     setSelectedMenu("7");
//     //     navigate("/transactionList");
//     //   },
//     // },
//     // {
//     //   key: "7",
//     //   icon: <VscSymbolProperty />,
//     //   label: "Properties",
//     //   title: "Properties",
//     //   onClick: () => {
//     //     setSelectedMenu("7");
//     //     navigate("/propertiesDetails");
//     //   },
//     // },
//     {
//       key: "8",
//       icon: <LogoutOutlined />,
//       label: "Sign Out",
//       title: "Sign Out",
//       onClick: () => {
//         setSelectedMenu("8");
//         getlogout();
//       },
//     },
//   ];

//   const currentMenuItem = menuItems.find((item) => item.key === selectedMenu);

//   // const finer = (fileSystem) => {
//   //  let Count = 0

//   //   for (let file in fileSystem) {
//   //     if(file == "files"){
//   //       fileSystem[file].map((item)=>(Count+=item))
//   //     }
//   //     console.log("==============>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",fileSystem[file]);
//   //     if(Array.isArray(fileSystem[file]) && fileSystem[file].every((item)=> typeof item == "object" ) ){
//   //       finer(fileSystem[file] )
//   //     }
//   //     else{
//   //       fileSystem.totalScore = ""
//   //     }
//   //   }


//   //   return fileSystem

//   // }

//   // const fileSystem = {
//   //   name: "root",
//   //   files: [1200, 3000], // Sizes in bytes
//   //   subdirectories: [
//   //     {
//   //       name: "subdir1",
//   //       files: [800],
//   //       subdirectories: [
//   //         {
//   //           name: "subsubdir1",
//   //           files: [400, 200],
//   //           subdirectories: [],
//   //         },
//   //       ],
//   //     },
//   //     {
//   //       name: "subdir2",
//   //       files: [1000, 500],
//   //       subdirectories: [],
//   //     },
//   //   ],
//   // };




//   // console.log(finer(fileSystem))


//   return (
//     <Layout style={layoutStyle} className="min-h-screen sidebar bg-[#edf2f9]">
//       <Header
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           position: "fixed",
//           width: "100%",
//           top: "0",
//           zIndex: "11",
//         }}
//       >
//         <div>
//           <p className="font-bold text-lg font-poppins">
//             Restaurant Management
//           </p>
//         </div>
//         <div className="flex justify-center items-center gap-3" >
//           <Link to={"/profile"} >
//             <UserOutlined

//               style={{ fontSize: "20px", cursor: "pointer", marginLeft: "15px" }}
//             />
//           </Link>


//           <LogoutOutlined
//             onClick={() => getlogout()}
//             style={{ fontSize: "20px", cursor: "pointer", marginLeft: "15px" }}
//           />
//           <div className="flex items-center gap-4">
//             <div>
//               <div className="flex items-center gap-2">
//                 <h3 className="text-lg font-bold text-white">{dashboard?.vendorPlan.planName}</h3>
//                 <Tag color={dashboard?.vendorPlan.status === "active" ? "success" : "default"} className="uppercase">
//                   {dashboard?.vendorPlan.status}
//                 </Tag>
//                 {dashboard?.vendorPlan.isFreeTrial && <Tag color="blue">Free Trial</Tag>}
//               </div>
//               <p className="text-xs text-white mt-1">
//                 {formatDate(dashboard?.vendorPlan.startDate)} — {formatDate(dashboard?.vendorPlan.endDate)}
//                 {" · "}
//                 {dashboard?.vendorPlan.isExpired ? "Expired" : `${dashboard?.vendorPlan.daysRemaining} days remaining`}
//               </p>
//             </div>
//           </div>
//         </div>

//       </Header>
//       <Layout>
//         <Sider
//           style={{ position: "fixed" }}
//           width="15%"
//           className="h-[100vh] z-10 text-center top-16"
//           collapsible
//           // width={290}
//           collapsed={collapsed}
//           onCollapse={() => setCollapsed(!collapsed)}
//         >
//           {/* <div className="demo-logo-vertical d-flex justify-content-center m-2 ">
//             <div>
//               <Avatar shape="square" size={64} icon={<UserOutlined />} />
//             </div>
//             {!collapsed ? (
//               <div className="w-full mt-2 p-2 h-16 gap-4">
//                 <p className="font-bold">Restaurant Vendor</p>
//               </div>
//             ) : (
//               <div className="w-5 mt-9 px-2  grid">

//                 <p className=" text-xs">Restaurant Vendor</p>
//               </div>
//             )}

//             {!collapsed ? (
//               <div className="w-full mt-2 p-2   justify-center text-center">
//                 <Link to={"/profile"} >
//                   <UserOutlined className="m-3" />{" "}
//                 </Link>

//                 <MessageOutlined className="m-3" />{" "}
//                 <LogoutOutlined onClick={() => getlogout()} className="m-3" />
//               </div>
//             ) : (
//               <div className="w-5 m-2 p-2  justify-center text-center">
//                 <UserOutlined className="m-2" />{" "}
//                 <MessageOutlined className="m-2" />{" "}
//                 <LogoutOutlined onClick={() => getlogout()} className="m-2" />
//               </div>
//             )}
//             <div className="border-b-2"></div>
//           </div> */}
//           <Menu
//             mode="inline"
//             className="text-base pb-24 font-inter"
//             selectedKeys={[selectedMenu]}
//           >
//             {menuItems.map((item) => (
//               <Menu.Item key={item.key} icon={item.icon} onClick={item.onClick}>
//                 {item.label}
//               </Menu.Item>
//             ))}
//           </Menu>
//         </Sider>
//         {collapsed ?
//           <Content
//             className="min-h-screen mt-16 ml-24 relative p-4"
//           >
//             {currentMenuItem?.title === "Dashboard" ? (
//               <div></div>
//             ) : (
//               <div className="w-full h-auto bg-white p-3 shadow-sm shadow-gray-300">
//                 <Breadcrumb
//                   items={[
//                     {
//                       title: (
//                         <div className="flex">
//                           <p>
//                             <MdDashboard className="font-bold text-2xl text-rgbaprimary8" />
//                           </p>
//                           <p className="text-base text-rgbaprimary8">
//                             {" "}
//                             Dashboard
//                           </p>
//                         </div>
//                       ),
//                     },
//                     {
//                       title: (

//                         <p className=" cursor-pointer text-base">{currentMenuItem?.title}</p>
//                       ),
//                     },
//                     trimRoute[1] == "restrolist" &&
//                     {

//                       title: (
//                         <p className="text-base">RestroList</p>
//                       ),
//                     },
//                   ]}
//                 />
//               </div>
//             )}

//             {children}
//           </Content>
//           :
//           <Content
//             className="min-h-screen relative p-4"
//             style={{
//               margin: "64px 0 0 15%",
//             }}
//           >
//             {currentMenuItem?.title === "Dashboard" ? (
//               <div></div>
//             ) : (
//               <div className="w-full h-auto bg-white p-3 shadow-sm shadow-gray-300">
//                 <Breadcrumb
//                   items={[
//                     {
//                       title: (
//                         <div className="flex">
//                           <p>
//                             <MdDashboard className="font-bold text-2xl text-rgbaprimary8" />
//                           </p>
//                           <p className="text-base text-rgbaprimary8">
//                             {" "}
//                             Dashboard
//                           </p>
//                         </div>
//                       ),
//                     },
//                     {
//                       title: (

//                         <p className=" cursor-pointer text-base">{currentMenuItem?.title}</p>
//                       ),
//                     },
//                     trimRoute[1] == "restrolist" &&
//                     {

//                       title: (
//                         <p className="text-base">RestroList</p>
//                       ),
//                     },
//                   ]}
//                 />
//               </div>
//             )}

//             {children}
//           </Content>
//         }

//       </Layout>
//     </Layout>
//   );
// };

// export default BasicLayout;




import React, { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Avatar, Breadcrumb, Layout, Menu, message, Tag } from "antd";
import { MdDashboard, MdOutlineSupervisedUserCircle } from "react-icons/md";
import {
  BellOutlined,
  BuildOutlined,
  HomeOutlined,
  LogoutOutlined,
  MessageOutlined,
  RestTwoTone,
  UserOutlined,
  WalletFilled,
  WalletTwoTone,
} from "@ant-design/icons";
import { TbCategoryPlus } from "react-icons/tb";
import { VscRequestChanges, VscSymbolProperty } from "react-icons/vsc";
import { GrServices } from "react-icons/gr";
import { Header } from "antd/es/layout/layout";
import { BiBuildingHouse, BiListCheck, BiTransfer, BiWallet } from "react-icons/bi";
import { useSelector } from "react-redux";
import { FaClipboardList, FaCrown } from "react-icons/fa";
import { getDashBoard } from "../ApiServices/Apifun";

const { Sider, Content } = Layout;

// Ring geometry — kept as constants so the SVG and the JS stay in sync.
const RING_RADIUS = 15;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

// One-time-injected styles for the plan chip. Deliberately compact —
// everything is sized to sit comfortably inside a 64px header row.
const PlanCardStyles = () => (
  <style>{`
    @keyframes planChipIn {
      from { opacity: 0; transform: translateY(-4px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes planShimmer {
      0% { background-position: -150% 0; }
      100% { background-position: 250% 0; }
    }
    @keyframes planPulseDot {
      0% { box-shadow: 0 0 0 0 rgba(52, 211, 153, 0.55); }
      70% { box-shadow: 0 0 0 6px rgba(52, 211, 153, 0); }
      100% { box-shadow: 0 0 0 0 rgba(52, 211, 153, 0); }
    }
    @keyframes planPulseDotIdle {
      0% { box-shadow: 0 0 0 0 rgba(203, 213, 225, 0.4); }
      70% { box-shadow: 0 0 0 5px rgba(203, 213, 225, 0); }
      100% { box-shadow: 0 0 0 0 rgba(203, 213, 225, 0); }
    }
    @keyframes planRingIn {
      from { stroke-dashoffset: ${RING_CIRCUMFERENCE}; }
    }

    .plan-chip {
      position: relative;
      display: flex;
      align-items: center;
      gap: 8px;
      height: 40px;
      max-height: 40px;
      box-sizing: border-box;
      padding: 0 14px 0 6px;
      border-radius: 999px;
      background: linear-gradient(180deg, rgba(255,255,255,0.16), rgba(255,255,255,0.05));
      border: 1px solid rgba(255,255,255,0.28);
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.18);
      animation: planChipIn 0.4s ease-out both;
      overflow: hidden;
      transition: border-color 0.2s ease, background 0.2s ease;
      cursor: default;
    }
    .plan-chip:hover {
      border-color: rgba(255,255,255,0.5);
      background: linear-gradient(180deg, rgba(255,255,255,0.22), rgba(255,255,255,0.08));
    }
    .plan-chip::before {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(
        100deg,
        transparent 25%,
        rgba(255,255,255,0.18) 48%,
        rgba(255,255,255,0.18) 52%,
        transparent 75%
      );
      background-size: 250% 100%;
      animation: planShimmer 3.5s ease-in-out infinite;
      pointer-events: none;
    }

    .plan-ring-wrap {
      position: relative;
      width: 30px;
      height: 30px;
      flex: none;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .plan-ring-svg {
      position: absolute;
      inset: 0;
      transform: rotate(-90deg);
    }
    .ring-track {
      fill: none;
      stroke: rgba(255,255,255,0.22);
      stroke-width: 2.5;
    }
    .ring-progress {
      fill: none;
      stroke-width: 2.5;
      stroke-linecap: round;
      transition: stroke-dashoffset 0.6s ease, stroke 0.3s ease;
      animation: planRingIn 0.8s ease-out both;
    }
    .ring-crown-icon {
      position: relative;
      font-size: 11px;
      color: #fde68a;
      z-index: 1;
    }

    .plan-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      line-height: 1;
      min-width: 0;
    }
    .plan-name-row {
      display: flex;
      align-items: center;
      gap: 6px;
      line-height: 14px;
    }
    .plan-name {
      font-size: 12.5px;
      font-weight: 700;
      color: #fff;
      letter-spacing: 0.15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 140px;
    }
    .status-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #cbd5e1;
      flex: none;
      animation: planPulseDotIdle 2.2s infinite;
    }
    .status-dot.active {
      background: #34d399;
      animation: planPulseDot 2.2s infinite;
    }
    .trial-chip {
      font-size: 8.5px;
      font-weight: 700;
      letter-spacing: 0.3px;
      text-transform: uppercase;
      color: #1e3a8a;
      background: linear-gradient(135deg, #bfdbfe, #93c5fd);
      padding: 1px 5px;
      border-radius: 999px;
      line-height: 1.4;
      flex: none;
    }

    .plan-sub-row {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-top: 3px;
      line-height: 11px;
    }
    .plan-days {
      font-size: 10px;
      font-weight: 600;
      color: #fff;
      white-space: nowrap;
    }
    .plan-days.expired {
      color: #fecaca;
    }
    .plan-sep {
      font-size: 10px;
      color: rgba(255,255,255,0.5);
    }
    .plan-dates {
      font-size: 10px;
      color: rgba(255,255,255,0.72);
      white-space: nowrap;
    }
  `}</style>
);

const BasicLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("");
  const parm = useLocation();
  const trimRoute = parm.pathname.split("/")
  const wallet = useSelector((state) => state.B2B.walletBal);
  const navigate = useNavigate();
  const [dashboard, setDashboard] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      window.innerWidth <= 600 ? setCollapsed(true) : setCollapsed(false);
    };
    window.addEventListener("resize", handleResize);
    const stored = localStorage.getItem("selected");
    if (stored) {
      setSelectedMenu(stored);
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchDashboard = () => {
    getDashBoard()
      .then((response) => {
        if (response.status) {
          setDashboard(response.data || null);
        }
      })
      .catch((err) => {
        console.error("Error fetching dashboard details:", err);
      });
  };
  useEffect(() => {
    fetchDashboard();
  }, []);

  useEffect(() => {
    localStorage.setItem("selected", selectedMenu);
  }, [selectedMenu]);

  function getlogout() {
    localStorage.clear();
    navigate("/");
    message.success("Vendor Logged Out Successfully");
  }

  const layoutStyle = {
    borderRadius: 8,
    overflow: "hidden",
  };
  const formatDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};
  // Shorter form (no year) for the compact chip; full date stays in the tooltip.
  const formatDateShort = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
  };

  // --- Plan chip derived values ---
  const vendorPlan = dashboard?.vendorPlan;
  const isActive = vendorPlan?.status === "active" && !vendorPlan?.isExpired;

  const planProgressPct = (() => {
    if (!vendorPlan?.startDate || !vendorPlan?.endDate) return 0;
    const start = new Date(vendorPlan.startDate).getTime();
    const end = new Date(vendorPlan.endDate).getTime();
    const now = Date.now();
    if (isNaN(start) || isNaN(end) || end <= start) return 0;
    if (vendorPlan.isExpired) return 100;
    const pct = ((now - start) / (end - start)) * 100;
    return Math.min(100, Math.max(0, pct));
  })();

  // Ring shows remaining time (100% full when plan just started, empties as it runs out).
  const ringRemainingPct = 100 - planProgressPct;
  const ringOffset = RING_CIRCUMFERENCE * (1 - ringRemainingPct / 100);

  const ringColor = vendorPlan?.isExpired
    ? "#f87171"
    : vendorPlan?.daysRemaining <= 5
    ? "#fbbf24"
    : "#34d399";

  // Add titles to each menu item
  const menuItems = [
    {
      key: "1",
      icon: <MdDashboard />,
      label: "Dashboard",
      title: "Dashboard",
      onClick: () => {
        setSelectedMenu("1");
        navigate("/dashboard");
      },
    },

    {
      key: "5",
      icon: <VscRequestChanges />,
      label: "Order List",
      title: "Order List",
      onClick: () => {
        setSelectedMenu("5");
        navigate("/orderlist");
      },
    },
    {
      key: "6",
      icon: <BiBuildingHouse />,
      label: "Restro List",
      title: "Restro List",
      onClick: () => {
        setSelectedMenu("6");
        navigate("/restroList");
      },
    },
    {
      key: "11",
      icon: <BiListCheck />,
      label: "Role Management",
      title: "Role Management",
      onClick: () => {
        setSelectedMenu("11");
        navigate("/permissionList");
      },
    },
    {
      key: "2",
      icon: <FaClipboardList />,
      label: "Plan Management",
      title: "Plan Management",
      onClick: () => {
        setSelectedMenu("2");
        navigate("/plans");
      },
    },
    // {
    //   key: "7",
    //   icon: <BiTransfer />,
    //   label: "Transaction List",
    //   title: "Transaction List",
    //   onClick: () => {
    //     setSelectedMenu("7");
    //     navigate("/transactionList");
    //   },
    // },
    // {
    //   key: "7",
    //   icon: <VscSymbolProperty />,
    //   label: "Properties",
    //   title: "Properties",
    //   onClick: () => {
    //     setSelectedMenu("7");
    //     navigate("/propertiesDetails");
    //   },
    // },
    {
      key: "8",
      icon: <LogoutOutlined />,
      label: "Sign Out",
      title: "Sign Out",
      onClick: () => {
        setSelectedMenu("8");
        getlogout();
      },
    },
  ];

  const currentMenuItem = menuItems.find((item) => item.key === selectedMenu);

  return (
    <Layout style={layoutStyle} className="min-h-screen sidebar bg-[#edf2f9]">
      <PlanCardStyles />
      <Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          width: "100%",
          top: "0",
          zIndex: "11",
          height: "64px",
          lineHeight: "normal",
          padding: "0 24px",
        }}
      >
        <div>
          <p className="font-bold text-lg font-poppins">
            Restaurant Management
          </p>
        </div>
        <div className="flex justify-center items-center gap-4">
          {vendorPlan && (
            <div
              className="plan-chip"
              title={`${formatDate(vendorPlan.startDate)} — ${formatDate(vendorPlan.endDate)}`}
            >
              <div className="plan-ring-wrap">
                <svg className="plan-ring-svg" viewBox="0 0 36 36">
                  <circle className="ring-track" cx="18" cy="18" r={RING_RADIUS} />
                  <circle
                    className="ring-progress"
                    cx="18"
                    cy="18"
                    r={RING_RADIUS}
                    stroke={ringColor}
                    strokeDasharray={RING_CIRCUMFERENCE}
                    strokeDashoffset={ringOffset}
                  />
                </svg>
                <FaCrown className="ring-crown-icon" />
              </div>
              <div className="plan-text">
                <div className="plan-name-row">
                  <span className="plan-name">{vendorPlan.planName}</span>
                  <span className={`status-dot ${isActive ? "active" : ""}`} />
                  {vendorPlan.isFreeTrial && (
                    <span className="trial-chip">Trial</span>
                  )}
                </div>
                <div className="plan-sub-row">
                  <span className={`plan-days ${vendorPlan.isExpired ? "expired" : ""}`}>
                    {vendorPlan.isExpired ? "Expired" : `${vendorPlan.daysRemaining}d left`}
                  </span>
                  <span className="plan-sep">·</span>
                  <span className="plan-dates">
                    {formatDateShort(vendorPlan.startDate)} – {formatDateShort(vendorPlan.endDate)}
                  </span>
                </div>
              </div>
            </div>
          )}

          <Link to={"/profile"}>
            <UserOutlined
              style={{ fontSize: "20px", cursor: "pointer" }}
            />
          </Link>

          <LogoutOutlined
            onClick={() => getlogout()}
            style={{ fontSize: "20px", cursor: "pointer" }}
          />
        </div>
      </Header>
      <Layout>
        <Sider
          style={{ position: "fixed" }}
          width="15%"
          className="h-[100vh] z-10 text-center top-16"
          collapsible
          // width={290}
          collapsed={collapsed}
          onCollapse={() => setCollapsed(!collapsed)}
        >
          <Menu
            mode="inline"
            className="text-base pb-24 font-inter"
            selectedKeys={[selectedMenu]}
          >
            {menuItems.map((item) => (
              <Menu.Item key={item.key} icon={item.icon} onClick={item.onClick}>
                {item.label}
              </Menu.Item>
            ))}
          </Menu>
        </Sider>
        {collapsed ?
          <Content
            className="min-h-screen mt-16 ml-24 relative p-4"
          >
            {currentMenuItem?.title === "Dashboard" ? (
              <div></div>
            ) : (
              <div className="w-full h-auto bg-white p-3 shadow-sm shadow-gray-300">
                <Breadcrumb
                  items={[
                    {
                      title: (
                        <div className="flex">
                          <p>
                            <MdDashboard className="font-bold text-2xl text-rgbaprimary8" />
                          </p>
                          <p className="text-base text-rgbaprimary8">
                            {" "}
                            Dashboard
                          </p>
                        </div>
                      ),
                    },
                    {
                      title: (

                        <p className=" cursor-pointer text-base">{currentMenuItem?.title}</p>
                      ),
                    },
                    trimRoute[1] == "restrolist" &&
                    {

                      title: (
                        <p className="text-base">RestroList</p>
                      ),
                    },
                  ]}
                />
              </div>
            )}

            {children}
          </Content>
          :
          <Content
            className="min-h-screen relative p-4"
            style={{
              margin: "64px 0 0 15%",
            }}
          >
            {currentMenuItem?.title === "Dashboard" ? (
              <div></div>
            ) : (
              <div className="w-full h-auto bg-white p-3 shadow-sm shadow-gray-300">
                <Breadcrumb
                  items={[
                    {
                      title: (
                        <div className="flex">
                          <p>
                            <MdDashboard className="font-bold text-2xl text-rgbaprimary8" />
                          </p>
                          <p className="text-base text-rgbaprimary8">
                            {" "}
                            Dashboard
                          </p>
                        </div>
                      ),
                    },
                    {
                      title: (

                        <p className=" cursor-pointer text-base">{currentMenuItem?.title}</p>
                      ),
                    },
                    trimRoute[1] == "restrolist" &&
                    {

                      title: (
                        <p className="text-base">RestroList</p>
                      ),
                    },
                  ]}
                />
              </div>
            )}

            {children}
          </Content>
        }

      </Layout>
    </Layout>
  );
};

export default BasicLayout;